import { isInvEntityId } from '#app/lib/boolean_tests'
import { looksLikeAnIsbn, normalizeIsbn } from '#app/lib/isbn'
import type { EntityUri, InvEntityUri, IsbnEntityUri } from '#server/types/entity'

export function findUri (text: string) {
  text = text.trim()
  if (isWikidataId.test(text)) text = 'wd:' + text
  if (caseInsensitiveEntityUri.test(text)) return text.replace('wd:q', 'wd:Q') as EntityUri
  if (isInvEntityId(text)) return ('inv:' + text) as InvEntityUri
  if (looksLikeAnIsbn(text)) return ('isbn:' + normalizeIsbn(text)) as IsbnEntityUri
}

const caseInsensitiveEntityUri = /^(wd:[Qq][1-9]\d*|inv:[0-9a-f]{32}|isbn:\w{10}(\w{3})?)$/

const isWikidataId = /^[Qq][1-9]\d*/
